import { createAction } from "redux-actions";

export const COUPON_LIST = "COUPON_LIST";
export const couponList = createAction(COUPON_LIST);

export const COUPON_DETAILS = "COUPON_DETAILS";
export const couponDetails = createAction(COUPON_DETAILS);

export const ADD_COUPON = "ADD_COUPON";
export const addCoupon = createAction(ADD_COUPON);

export const UPDATE_COUPON = "UPDATE_COUPON";
export const updateCoupon = createAction(UPDATE_COUPON);

export const DELETE_COUPON = "DELETE_COUPON";
export const deleteCoupon = createAction(DELETE_COUPON);
